import { LegalLayout } from "@/pages/legal/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Privacy Policy"
      path="/privacy-policy"
      lastUpdated="September 1, 2026"
      seoTitle="Privacy Policy | Legacy Spa"
      seoDescription="Legacy Spa Privacy Policy — how we collect, use, and protect information, including SMS/text messaging and mobile data."
      intro="How Legacy Spa collects, uses, and protects your information — including phone calls, email, and SMS communications."
      sections={[
        {
          heading: "Overview",
          body: [
            "Legacy Spa (\u201cLegacy Spa,\u201d \u201cwe,\u201d \u201cus,\u201d or \u201cour\u201d) is a massage and wellness business located in Houston, Texas. This Privacy Policy explains how we collect, use, disclose, and protect information when you visit thelegacyspa.com, contact us, book or receive services, or communicate with us by phone, email, or SMS/text message.",
            "By using our website or providing your information to Legacy Spa, you agree to the practices described in this Privacy Policy.",
          ],
        },
        {
          heading: "Information We Collect",
          body: [
            "We may collect information through our website, booking forms, contact forms, phone calls, email, SMS/text messages, appointment and scheduling systems, and other interactions with Legacy Spa. This may include:",
          ],
          list: [
            "Contact details such as your name, phone number, email address, and city.",
            "Appointment and service details you provide when booking or inquiring.",
            "Communications you send us, including messages, call details, and preferences (such as your preferred contact method).",
            "Business or organization details when you submit a corporate, partnership, or team-interest inquiry.",
            "Consent records, including whether you opted in to receive SMS messages, and the date, time, and source of that consent.",
            "Website usage information collected automatically through cookies and analytics (see \u201cCookies & Analytics\u201d below).",
          ],
        },
        {
          heading: "How We Use Your Information",
          body: ["Legacy Spa may use the information we collect to:"],
          list: [
            "Respond to inquiries.",
            "Schedule and manage appointments.",
            "Provide massage and wellness services.",
            "Provide customer support.",
            "Send appointment confirmations and reminders.",
            "Make requested or appropriate business-related phone calls.",
            "Send service-related communications.",
            "Send promotional or marketing communications when the recipient has provided the required consent.",
            "Improve Legacy Spa\u2019s services and website.",
            "Maintain security and comply with applicable laws.",
          ],
        },
        {
          heading: "SMS / Text Messaging Privacy",
          body: [
            "When a customer provides their mobile number and affirmatively opts in to receive SMS communications, Legacy Spa may use that number to send the categories of messages described at the point of consent (for example, appointment confirmations, appointment reminders, scheduling and customer-service communications, service updates, and\u2014where separately authorized\u2014promotional or marketing messages).",
            "The following principles apply to our SMS communications:",
          ],
          list: [
            "SMS consent is voluntary.",
            "Consent is not a condition of purchase. Consent to receive marketing SMS messages is not required to purchase any goods or services.",
            "Message frequency may vary.",
            "Message and data rates may apply.",
            "Customers may reply STOP to unsubscribe from applicable SMS communications.",
            "Customers may reply HELP for assistance, or contact Legacy Spa at info@thelegacyspa.com or (832) 243-8853.",
            "Legacy Spa will honor applicable opt-out requests.",
          ],
        },
        {
          heading: "Mobile Information & Data Protection",
          body: [
            "Mobile information, including phone numbers and SMS opt-in/consent data, will not be sold, rented, or shared with third parties or affiliates for their own marketing or promotional purposes.",
            "SMS opt-in data and consent records are not shared with third parties for unrelated marketing purposes. Information may be disclosed to service providers that help Legacy Spa deliver communications or operate its services, solely as necessary to provide those services and subject to appropriate confidentiality and use restrictions.",
            "SMS opt-in and consent data will not be shared with third parties for their own marketing purposes.",
          ],
        },
        {
          heading: "Cookies & Analytics",
          body: [
            "Our website may use cookies and privacy-conscious analytics to understand general site usage, remember preferences, and improve performance. You can control cookies through your browser settings; disabling cookies may affect some website features.",
          ],
        },
        {
          heading: "Third-Party Service Providers",
          body: [
            "Legacy Spa uses trusted third-party providers to operate our business, including booking and payment providers (such as Vagaro), customer-relationship-management (CRM) systems, communications and SMS platforms, email delivery providers, and analytics services. These providers process information only as needed to provide services to Legacy Spa and are expected to protect your information consistent with this Privacy Policy and applicable law.",
          ],
        },
        {
          heading: "Booking & Payment Providers",
          body: [
            "Appointments are booked through Vagaro. Any information you provide during booking or payment is handled by Vagaro and applicable payment processors under their own terms and privacy practices.",
          ],
        },
        {
          heading: "Data Retention",
          body: [
            "We retain information for as long as necessary to fulfill the purposes described in this Privacy Policy, provide services, maintain records (including consent records), resolve disputes, and comply with legal obligations. When information is no longer needed, we take reasonable steps to delete or de-identify it.",
          ],
        },
        {
          heading: "Security",
          body: [
            "We use reasonable administrative, technical, and physical safeguards designed to protect your information. No method of transmission or storage is completely secure, and we cannot guarantee absolute security. Please avoid sending sensitive information (such as medical history, financial account numbers, or government identifiers) through website forms.",
          ],
        },
        {
          heading: "Your Choices",
          body: [
            "You may opt out of marketing SMS messages at any time by replying STOP, and you may contact us to update your preferences. You may also decline promotional communications while continuing to receive service-related messages necessary to fulfill your requests or appointments.",
          ],
        },
        {
          heading: "Changes to This Policy",
          body: [
            "We may update this Privacy Policy from time to time. The \u201cLast Updated\u201d date above reflects the most recent revision. Continued use of our website or services after changes take effect constitutes acceptance of the updated policy.",
          ],
        },
        {
          heading: "Contact Us",
          body: [
            "Questions about this Privacy Policy can be directed to Legacy Spa in Houston, Texas at info@thelegacyspa.com or (832) 243-8853.",
          ],
        },
      ]}
    />
  );
}
